function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import "core-js/modules/web.dom-collections.iterator.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getFullStoryDataPointElementProps } from 'features/fullstory/getFullStoryDataPointElementProps';
import { forwardRef, useCallback } from 'react';
import styled, { css, useTheme } from 'styled-components';
import useControlled from '../../../hooks/useControlled';
import Icon from '../Icon';
import IconButton from '../IconButton';
const Text = css([
    `font-family:`,
    `;letter-spacing:`,
    `;font-weight:`,
    `;`,
    `;`
], (p)=>p.theme.typography.fontFamily.body, (p)=>p.theme.typography.letterSpacing.paragraph, (p)=>p.theme.typography.fontWeightRegular, (p)=>p.theme.typography.getfontSizes('body'));
const iconStyle = ({ color })=>`
  svg {
    path {
      fill: ${color};
    }
    rect {
      fill: ${color};
    }
  }
`;
const Container = styled.div.withConfig({
    componentId: "sc-76c868d-0"
})([
    `position:relative;display:flex;flex-direction:column;width:`,
    `;`
], (p)=>p.$width);
const StyledInput = styled.input.withConfig({
    componentId: "sc-76c868d-1"
})([
    `outline:none;box-shadow:none;`,
    ` line-height:`,
    `;transition:200ms cubic-bezier(0,0,0.2,1) 0ms;padding:`,
    `;height:`,
    `;border-radius:`,
    `px;padding-left:`,
    `;`,
    ` `,
    ``
], Text, (p)=>p.theme.typography.lineHeight.default, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, 0, 2);
}, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, p.$height);
}, (p)=>p.theme.shape.borderRadius.full, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, p.$spacing);
}, (p)=>p.$style === 'box' && css([
        `background-color:#f0f1f1;border:none;&:hover{background-color:#f0f3f3;color:`,
        `;}&:focus,&:active{background-color:#f0f1f1;color:`,
        `;}&:disabled{background:#f9f9f9;color:`,
        `;}`
    ], (p)=>{
        var _p_theme_colors_light;
        return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.default.hover;
    }, (p)=>{
        var _p_theme_colors_light;
        return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.default.default;
    }, (p)=>{
        var _p_theme_colors_light;
        return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutral.disabled;
    }), (p)=>p.$style === 'outline' && css([
        `background-color:#ffffff;border:1px solid `,
        `;&:hover{background-color:#f1f1f1;border:1px solid `,
        `;}&:focus,&:active{background-color:#ffffff;border:1px solid `,
        `;}&:disabled{background:#f9f9f9;border:1px solid `,
        `;}`
    ], (p)=>{
        var _p_theme_colors_light;
        return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.bordersStates.neutral.default;
    }, (p)=>p.theme.colors.nero[300].hover, (p)=>{
        var _p_theme_colors_light;
        return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.bordersStates.default.default;
    }, (p)=>{
        var _p_theme_colors_light;
        return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.bordersStates.default.disabled;
    }));
const Wrapper = css([
    `position:absolute;display:flex;top:50%;transform:translateY(-50%);`
]);
const StyledIcon = styled.div.withConfig({
    componentId: "sc-76c868d-2"
})([
    ``,
    `;`,
    `:hover ~ &{`,
    `;}`,
    `:focus ~ &,`,
    `:active ~ &{`,
    `;}`,
    `:disabled ~ &{`,
    `;}`
], (p)=>{
    var _p_theme_colors_light;
    return iconStyle({
        color: (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutral.default
    });
}, StyledInput, (p)=>{
    var _p_theme_colors_light;
    return iconStyle({
        color: (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutralOnBg.hover
    });
}, StyledInput, StyledInput, (p)=>{
    var _p_theme_colors_light;
    return iconStyle({
        color: (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutral.default
    });
}, StyledInput, (p)=>{
    var _p_theme_colors_light;
    return iconStyle({
        color: (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutral.disabled
    });
});
const StyledLeftIcon = styled(StyledIcon).withConfig({
    componentId: "sc-76c868d-3"
})([
    ``,
    ` left:`,
    `;`
], Wrapper, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, p.$spacing);
});
const Label = styled.label.withConfig({
    componentId: "sc-76c868d-4"
})([
    ``,
    ` display:flex;align-items:center;position:absolute;pointer-events:none;top:50%;color:`,
    `;transform:translate(0,-50%);transform-origin:top left;transition:200ms cubic-bezier(0,0,0.2,1) 0ms;overflow:hidden;text-align:left;text-overflow:ellipsis;white-space:nowrap;left:`,
    `;`,
    `:hover ~ &{color:`,
    `;}`,
    `:focus ~ &,`,
    `:active ~ &{color:`,
    `;}`,
    `:disabled ~ &{color:`,
    `;}`
], Text, (p)=>{
    var _p_theme_colors_light;
    return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutral.default;
}, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, p.$spacing);
}, StyledInput, (p)=>{
    var _p_theme_colors_light;
    return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutralOnBg.hover;
}, StyledInput, StyledInput, (p)=>{
    var _p_theme_colors_light;
    return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutral.default;
}, StyledInput, (p)=>{
    var _p_theme_colors_light;
    return (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutral.disabled;
});
const StyledClearButton = styled(StyledIcon).withConfig({
    componentId: "sc-76c868d-5"
})([
    ``,
    ` right:`,
    `;`,
    `:focus ~&,`,
    `:active ~&{&:hover{cursor:pointer;`,
    `;}}`
], Wrapper, (p)=>{
    var _p_theme_spacing, _p_theme;
    var _p_$spacing;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, (_p_$spacing = p.$spacing) !== null && _p_$spacing !== void 0 ? _p_$spacing : 0);
}, StyledInput, StyledInput, (p)=>{
    var _p_theme_colors_light;
    return iconStyle({
        color: (_p_theme_colors_light = p.theme.colors.light) === null || _p_theme_colors_light === void 0 ? void 0 : _p_theme_colors_light.textStates.neutral.hover
    });
});
const StyledIconButton = styled(IconButton).withConfig({
    componentId: "sc-76c868d-6"
})([
    ``,
    ` right:`,
    `;`
], Wrapper, (p)=>{
    var _p_theme_spacing, _p_theme;
    return (_p_theme_spacing = (_p_theme = p.theme).spacing) === null || _p_theme_spacing === void 0 ? void 0 : _p_theme_spacing.call(_p_theme, p.$spacing || 0);
});
/**
 * FieldSimple is a less complex input component that can be used for simpler interactions like searching or filtering.
 *
 * If you want an input for a typical user data collection form, use the Field component.
 *
 * All other props will be forwarded to the root component.
 */ const FieldSimple = /*#__PURE__*/ forwardRef(function FieldSimple(props, ref) {
    const { className, defaultValue, disabled = false, fieldSize = 'large', icon, buttonColor = 'brandOne', outline = false, label, name, onChange, onSubmit, onKeyDown, placeholder, readOnly = false, type = 'text', value: valueProp, width = 'auto', onClear, fullStoryDataPoint } = props, other = _object_without_properties(props, [
        "className",
        "defaultValue",
        "disabled",
        "fieldSize",
        "icon",
        "buttonColor",
        "outline",
        "label",
        "name",
        "onChange",
        "onSubmit",
        "onKeyDown",
        "placeholder",
        "readOnly",
        "type",
        "value",
        "width",
        "onClear",
        "fullStoryDataPoint"
    ]);
    const [value, setValue] = useControlled({
        controlled: valueProp,
        default: defaultValue && !valueProp && !onChange ? defaultValue : '',
        name: 'Field',
        state: 'value'
    });
    const handleChange = useCallback((e)=>{
        setValue(e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    }, [
        setValue,
        onChange
    ]);
    const withIcon = !!icon;
    const showLabel = !value && !placeholder;
    const theme = useTheme();
    const { size } = theme.fieldSimple;
    const textSpacing = size[fieldSize].leftSpacing + (withIcon ? 4 : 1);
    const handleOnClear = ()=>{
        onClear === null || onClear === void 0 ? void 0 : onClear();
        setValue('');
    };
    return /*#__PURE__*/ _jsxs(Container, _object_spread_props(_object_spread({
        $width: width,
        className: className
    }, getFullStoryDataPointElementProps(fullStoryDataPoint)), {
        children: [
            /*#__PURE__*/ _jsx(StyledInput, _object_spread({
                ref: ref,
                $height: size[fieldSize].height,
                $spacing: textSpacing,
                $style: outline ? 'outline' : 'box',
                className: className,
                disabled: disabled,
                id: name,
                name: name,
                placeholder: placeholder,
                readOnly: readOnly,
                type: type,
                value: value,
                onChange: handleChange,
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' && onSubmit) {
                        onSubmit(value);
                    }
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                }
            }, other)),
            icon && /*#__PURE__*/ _jsx(StyledLeftIcon, {
                $spacing: size[fieldSize].leftSpacing,
                children: /*#__PURE__*/ _jsx(Icon, {
                    name: icon
                })
            }),
            showLabel && /*#__PURE__*/ _jsx(Label, {
                $spacing: textSpacing,
                htmlFor: name,
                children: label
            }),
            value && /*#__PURE__*/ _jsx(StyledClearButton, {
                $clearIcon: true,
                $spacing: size[fieldSize].clearIconSpacing,
                onClick: handleOnClear,
                children: /*#__PURE__*/ _jsx(Icon, {
                    name: "ActionClose"
                })
            }),
            /*#__PURE__*/ _jsx(StyledIconButton, {
                $spacing: fieldSize === 'extra' || fieldSize === 'medium' ? 1 : 0.5,
                color: buttonColor,
                disabled: disabled,
                icon: size[fieldSize].buttonIcon,
                size: size[fieldSize].buttonSize,
                type: "submit",
                onClick: ()=>onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value)
            })
        ]
    }));
});
export default FieldSimple;
